import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { renderFieldSelect } from '../../util/inputs';
import { Field } from 'redux-form';
// import buscarCtesDisponiveisMdfe from '../../actions/mdfe/buscarCtesDisponiveisMdfe';

export class FormAdicionarCteMdfe extends Component {

    exibirCtesVinculados() {
        if (!this.props.ctesVinculados || this.props.ctesVinculados.length === 0) {
            return (
                <tr className="alert alert-warning text-center mt-4" role="alert">
                    <td colSpan='6'>Nenhum CT-e vinculado.</td>
                </tr>
            )
        }
        return this.props.ctesVinculados.map((it, index) => (
            <tr key={`cte-vinculado-mdfe-${index}`}>
                <td>{it.pedidoId}</td>
                <td>{it.origem}</td>
                <td>{it.destino}</td>
                <td>{it.chaveCte}</td>
                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                    {this.props.exibirBotaoSalvar() && (
                        <div onClick={(e) => { e.preventDefault(); this.props.removerCteVinculado(it.chaveCte) }}>
                            Remover
                        </div>
                    )}
                </td>
            </tr>
        ))
    }

    render() {
        return (
            <div>
                {this.props.exibirBotaoSalvar() && (
                    <div className="form-row mb-4">
                        <div className="col-12 col-sm-10 col-md-10">
                            <Field
                                name='cteDisponivel'
                                options={(this.props.ctesDisponiveis || []).map(it => ({
                                    descricao: `Pedido: ${it.pedidoId} | Origem: ${it.origem} | Destino: ${it.destino} | Chave: ${it.chaveCte}`,
                                    nome: it
                                }))}
                                component={renderFieldSelect}
                                label='CT-e disponível:'
                                placeholder='Selecione um CT-e para vincular...'
                                onChange={(e) => this.props.handleSelecionarCte(e)}
                            />
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 d-flex align-items-end">
                            <button
                                type="button"
                                className="vx-btn-primary"
                                onClick={() => this.props.adicionarCteVinculado()}>
                                <i className="material-icons">add</i>
                                Adicionar
                            </button>
                        </div>
                    </div>
                )}

                <table className="table table-sm table-bordered mt-2">
                    <thead>
                        <tr className='text-center'>
                            <th colSpan='6'>CT-es Vinculados</th>
                        </tr>
                        <tr>
                            <th>Nº Pedido</th>
                            <th>Origem</th>
                            <th>Destino</th>
                            <th>Chave CT-e</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {this.exibirCtesVinculados()}
                    </tbody>
                </table>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,        
        ctesDisponiveis: state.opcoesFiltrosEmissoesMdfe.ctesDisponiveisMDFe,        
    }
}

export default connect(mapStateToProps, {})(reduxForm({
    form: 'formularioCadastroMdfe'
})(FormAdicionarCteMdfe));
